import React from 'react';
import { FlaskConicalIcon, UserPlusIcon } from 'lucide-react';
import { useDataMode } from '../../contexts/DataModeContext';

/**
 * States plainly which of the two the person is looking at.
 *
 * Seeded records must never be mistaken for a real account's activity, so the
 * label sits above the product rather than buried on one admin page.
 */
export function DataModeBanner() {
  const {
    mode,
    setMode
  } = useDataMode();
  const demo = mode === 'demo';
  return <div className={`border-b ${demo ? 'border-warn-100 bg-warn-50' : 'border-brand-200 bg-brand-50'}`} data-id="element-3949" data-mp="3jjm6ce0dxj9a">
      <div className="mx-auto flex w-full max-w-[1400px] flex-wrap items-center gap-x-4 gap-y-2 px-4 py-2 sm:px-6" data-id="element-3950" data-mp="3tbjlfvuikvda">
        <p className="flex min-w-0 items-start gap-2 text-body-sm text-ink" data-id="element-3951" data-mp="258ejj2tp0e1">
          {demo ? <FlaskConicalIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-warn-700" data-id="element-3952" data-mp="74us5tmkcind" /> : <UserPlusIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-brand-700" data-id="element-3953" data-mp="b6oq3u5dj8ju" />}
          <span data-id="element-3954" data-mp="k2rtc7hr27xf">
            <span className="font-semibold" data-id="element-3955" data-mp="k3bctsn1t4dk">
              {demo ? 'Demonstration data.' : 'New account view.'}
            </span>{' '}
            {demo ? 'These courses, orders, matches and notes are seeded records for review — not real activity, and not production metrics.' : 'Every surface is showing what a person with nothing on their account would actually see.'}
          </span>
        </p>
        <button type="button" onClick={() => setMode(demo ? 'new' : 'demo')} className="ml-auto shrink-0 rounded-md px-2 py-1 text-body-sm font-semibold text-brand-700 underline decoration-brand-700/40 underline-offset-2 transition-colors duration-150 ease-out hover:text-brand-800" data-id="element-3956" data-mp="12u2l0qvauoqd">
          {demo ? 'View as a new account' : 'Show demonstration data'}
        </button>
      </div>
    </div>;
}